export default {"src":"/evde-internet/_next/static/media/alert.459e09f8.svg","height":36,"width":36};